import firebase from "firebase/app";

const getValueAt = location => {
    const ref = firebase.database().ref(location);
    return ref.once("value").then(snapshot => snapshot.val());
};

const updateValueAt = location => value => {
    const ref = firebase.database().ref(location);
    return ref.update(value);
};

const getUserId = () => firebase.auth().currentUser.uid;

export const updateUserSubject = userSubject => {
    const userId = getUserId();
    return updateValueAt(`userSubjects/${userId}/${userSubject.id}`)(
        userSubject
    );
};



// WEBPACK FOOTER //
// ./src/store/sagas/firebaseDataSync/clients/clients.js